// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"f2232fca","950":"4b60493f"}[chunkId] + ".chunk.js";
};